import React, { useRef, useState } from 'react';
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { TextField } from '@mui/material';

const ScrollingTimePicker = ({ name, label, timesteps, onChange, ...props }) => {
	const [scrollbarOpen, setScrollbarOpen] = useState(false);
	const popperAnchorRef = useRef();

	const handleChange = t => {
		const time = t?.getTime();
		const v = (!t || Number.isNaN(time)) ? null : t;
		onChange({ target: { name, value: v } });
		setScrollbarOpen(false);
	};

	return (
		<LocalizationProvider dateAdapter={AdapterDateFns}>
			<div ref={popperAnchorRef}>
				<TimePicker
					open={scrollbarOpen}
					slots={{
						textField: (params) => (
							<TextField
		                    {...params}
		                    InputProps={{
			                    ...params.InputProps,
			                    readOnly: true,
		                    }}
		                    onClick={() => setScrollbarOpen(true)}
	                    />
						),
					}}
					label={label || 'Time'}
					ampm={false}
					timeSteps={timesteps}
					onAccept={handleChange}
					onClose={(e) => setScrollbarOpen(false)}
					slotProps={{
						popper: {
							anchorEl: popperAnchorRef.current,
						},
					}}
					{...props}
				/>
			</div>
		</LocalizationProvider>
	);
};

ScrollingTimePicker.type = 'ScrollingTimePicker';
export default ScrollingTimePicker;